var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13L3 7.5L6 5L9 8L8.5 12L14 16L16.5 14.5L19.5 18L17 21L8.5 18.5L4 13Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5662 21.999C16.5712 21.999 16.5892 21.999 16.5942 21.999C17.1222 21.999 17.6212 21.791 17.9992 21.413L20.7112 18.701C21.1022 18.31 21.1022 17.678 20.7112 17.287L16.7112 13.287C16.3202 12.896 15.6882 12.896 15.2972 13.287L13.7032 14.881C12.9642 14.661 11.5852 14.161 10.7112 13.287C9.83722 12.413 9.33722 11.034 9.11722 10.295L10.7112 8.701C11.1022 8.31 11.1022 7.678 10.7112 7.287L6.71122 3.287C6.33622 2.912 5.67222 2.912 5.29722 3.287L2.58622 5.999C2.20622 6.379 1.99222 6.901 2.00022 7.434C2.02322 8.858 2.40022 13.804 6.29822 17.702C10.1962 21.6 15.1422 21.976 16.5662 21.999ZM6.00522 5.408L8.59122 7.994L7.29822 9.287C7.05922 9.525 6.95722 9.869 7.02722 10.199C7.05122 10.314 7.63822 13.041 9.29822 14.701C10.9582 16.361 13.6852 16.948 13.8002 16.972C14.1332 17.042 14.4742 16.94 14.7122 16.701L16.0052 15.408L18.5912 17.994L16.5852 19.999C15.3372 19.978 11.0672 19.643 7.71222 16.287C4.34622 12.921 4.02022 8.636 4.00022 7.413L6.00522 5.408ZM19.9992 10.999H21.9992C21.9992 5.869 18.1262 2 12.9892 2V4C17.0512 4 19.9992 6.943 19.9992 10.999Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.999 8C15.102 8 15.999 8.897 15.999 11H17.999C17.999 7.775 16.224 6 12.999 6V8Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8c2da9b0.svg";
export { ForwardRef as ReactComponent };